import { useEffect, useState } from "react";
import MasterLayout from "../Sections/MasterLayout";
import { useParams, useNavigate } from "react-router-dom";
import {
  server_post_data,
  save_update_station,
  get_all_cities,
  get_all_lines,
  get_station_by_id,
} from "../../ServiceConnection/serviceconnection";
import Loader from "./Loader";
import SuccesModal from "../Sections/SuccesModal";

export default function AddStations() {
  const { station_id } = useParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [allcity, setallcity] = useState([]);
  const [alllines, setalllines] = useState([]);
  const [station, setstation] = useState([]);
  const [formData, setFormData] = useState({
    stationName: "",
    stationCode: "",
    lines: [],
    latitude: "",
    longitude: "",
    firstTrain: "",
    lastTrain: "",
    frequency: "",
    city: "",
  });
  const [errors, setErrors] = useState({});

  const handleKeyDown = (e) => {
    if (["e", "E", "+", "-"].includes(e.key)) {
      e.preventDefault();
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleLineChange = (lineValue, checked) => {
    setFormData((prev) => ({
      ...prev,
      lines: checked
        ? [...prev.lines, lineValue]
        : prev.lines.filter((line) => line !== lineValue),
    }));

    if (checked) {
      setErrors((prev) => ({
        ...prev,
        lines: "",
      }));
    }
  };

  const handleCityChange = (e) => {
    const selectedPrefix = e.target.value;
    const selectedCity = allcity.find(
      (city) => city.table_prefix === selectedPrefix
    );

    if (selectedCity) {
      setFormData((prev) => ({
        ...prev,
        city: selectedCity.table_prefix,
      }));

      setErrors((prev) => ({
        ...prev,
        city: "",
      }));

      getallline(selectedCity.primary_id);
    }
  };

  const validate = () => {
    const newErrors = {};
    const {
      stationName,
      stationCode,
      lines,
      latitude,
      longitude,
      firstTrain,
      lastTrain,
      frequency,
      city,
    } = formData;

    if (!stationName) newErrors.stationName = "Station name is required";
    if (!stationCode.match(/^[A-Z]{2,5}$/))
      newErrors.stationCode = "Must be 2-5 uppercase letters";
    if (!lines.length) newErrors.lines = "Select at least one line";
    if (!latitude.match(/^(-?\d+(\.\d+)?)$/))
      newErrors.latitude = "Invalid latitude format";
    if (!longitude.match(/^(-?\d+(\.\d+)?)$/))
      newErrors.longitude = "Invalid longitude format";
    if (!firstTrain) newErrors.firstTrain = "First train time is required";
    if (!lastTrain) newErrors.lastTrain = "Last train time is required";
    if (!frequency.match(/^\d{1,2}$/))
      newErrors.frequency = "Must be 1-2 digits only";
    if (!city) newErrors.city = "City is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  useEffect(() => {
    getallcity();
  }, []);

  const getallcity = async () => {
    setIsLoading(true);
    try {
      const response = await server_post_data(get_all_cities, null);
      setallcity(response.data.data);
      console.log("Fetched cities:", response.data.data); // Debug log
    } catch (error) {
      console.error("Error fetching cities:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (station_id) {
      getallcitybyid();
    }
  }, [station_id]);

  const getallcitybyid = async () => {
    setIsLoading(true);
    try {
      let fd = new FormData();
      fd.append("station_id", station_id);
      fd.append("city_prefix", "indore_metro");
      const response = await server_post_data(get_station_by_id, fd);
      setstation(response.data.data);
      console.log("Fetched station:", response.data.data); // Debug log
    } catch (error) {
      console.error("Error fetching station:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (station.length > 0 && allcity.length > 0) {
      const stationData = station[0];
      // Check if stationData has city_prefix; otherwise, use hardcoded value
      const cityPrefix = stationData.city_prefix || "indore_metro";
      const selectedCity = allcity.find(
        (city) => city.table_prefix === cityPrefix
      );

      console.log("Mapping station data:", {
        stationData,
        cityPrefix,
        selectedCity,
        allcity,
        formDataCity: formData.city,
      }); // Debug log

      setFormData({
        stationName: stationData.name || "",
        stationCode: stationData.code || "",
        lines: stationData.multiple_line ? stationData.multiple_line.split(",") : [],
        latitude: stationData.latitude ? stationData.latitude.toString() : "",
        longitude: stationData.longitude ? stationData.longitude.toString() : "",
        firstTrain: stationData.first_train || "",
        lastTrain: stationData.last_train || "",
        frequency: stationData.frequency_minutes ? stationData.frequency_minutes.toString() : "",
        city: selectedCity ? selectedCity.table_prefix : "",
      });

      if (selectedCity) {
        getallline(selectedCity.primary_id);
      } else {
        console.warn("No matching city found for table_prefix:", cityPrefix);
      }
    }
  }, [station, allcity]);

  const getallline = async (city_id) => {
    setIsLoading(true);
    try {
      let fd = new FormData();
      fd.append("city_id", city_id);
      const response = await server_post_data(get_all_lines, fd);
      setalllines(response.data.data);
      console.log("Fetched lines:", response.data.data); // Debug log
    } catch (error) {
      console.error("Error fetching lines:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDynamic = async () => {
    setIsLoading(true);
    try {
      let fd = new FormData();
      fd.append("name", formData.stationName);
      fd.append("code", formData.stationCode);
      fd.append("multiple_line", formData.lines.join(","));
      fd.append("latitude", formData.latitude);
      fd.append("longitude", formData.longitude);
      fd.append("first_train", formData.firstTrain);
      fd.append("last_train", formData.lastTrain);
      fd.append("frequency_minutes", formData.frequency);
      fd.append("city_prefix", formData.city);
      if (station_id) {
        fd.append("station_id", station_id);
      }

      await server_post_data(save_update_station, fd);
      setFormData({
        stationName: "",
        stationCode: "",
        lines: [],
        latitude: "",
        longitude: "",
        firstTrain: "",
        lastTrain: "",
        frequency: "",
        city: "",
      });
      setErrors({});
      setShowSuccessModal(true);

      setTimeout(() => {
        setShowSuccessModal(false);
        navigate(-1);
      }, 2000);
    } catch (error) {
      console.error("Error saving station:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      await handleDynamic();
    }
  };

  return (
    <MasterLayout>
      {isLoading && <Loader />}
      <div className="max-w-5xl">
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden mb-3">
          <div className="border-b border-[#dee3e7] text-[var(--black)] p-6">
            <h2 className="text-xl font-semibold flex items-center gap-2">
              <svg
                className="h-6 w-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7"
                />
              </svg>
              Station Information
            </h2>
            <p className="text-[var(--grey-text)] mt-1">
              Fill in all required fields to {station_id ? "update" : "add"} a station to the system
            </p>
          </div>

          <div className="p-8">
            <form className="space-y-8">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="space-y-2">
                  <label
                    htmlFor="stationName"
                    className="text-sm font-medium text-[var(--grey-text)] flex items-center gap-2"
                  >
                    <svg
                      className="h-4 w-4"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-4m-5 0H3m2 0h4M9 7h6m-6 4h6m-6 4h6"
                      />
                    </svg>
                    Station Name *
                  </label>
                  <input
                    id="stationName"
                    name="stationName"
                    type="text"
                    placeholder="Enter station name"
                    value={formData.stationName}
                    onChange={handleChange}
                    className={`w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                      errors.stationName ? "border-red-500" : "border-gray-300"
                    }`}
                  />
                  {errors.stationName && (
                    <p className="text-sm text-red-500">{errors.stationName}</p>
                  )}
                </div>

                <div className="space-y-2">
                  <label
                    htmlFor="stationCode"
                    className="block text-sm font-medium text-[var(--grey-text)]"
                  >
                    Station Code *
                  </label>
                  <input
                    id="stationCode"
                    name="stationCode"
                    type="text"
                    placeholder="e.g., DLHI"
                    value={formData.stationCode}
                    onChange={(e) => {
                      setFormData((prev) => ({
                        ...prev,
                        stationCode: e.target.value.toUpperCase(),
                      }));
                      setErrors((prev) => ({
                        ...prev,
                        stationCode: "",
                      }));
                    }}
                    className={`w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                      errors.stationCode ? "border-red-500" : "border-gray-300"
                    }`}
                  />
                  {errors.stationCode && (
                    <p className="text-sm text-red-500">{errors.stationCode}</p>
                  )}
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="space-y-2">
                  <label className="block text-sm font-medium text-[var(--grey-text)]">
                    Metro Lines *
                  </label>
                  <div className="border rounded-lg p-4 bg-gray-50">
                    {alllines.length === 0 ? (
                      <p className="text-sm text-gray-500">
                        Please Select City First
                      </p>
                    ) : (
                      <div className="flex flex-wrap gap-4">
                        {alllines.map((line) => (
                          <div
                            key={line.name}
                            className="flex items-center gap-2"
                          >
                            <input
                              type="checkbox"
                              id={line.name}
                              checked={formData.lines.includes(line.name)}
                              onChange={(e) =>
                                handleLineChange(line.name, e.target.checked)
                              }
                              className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                            />
                            <label
                              htmlFor={line.name}
                              className="flex items-center gap-2 cursor-pointer text-sm"
                            >
                              <div
                                className={`w-3 h-3 rounded-full ${line.name.toLowerCase()}`}
                              />
                              {line.name}
                            </label>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                  {errors.lines && (
                    <p className="text-sm text-red-500">{errors.lines}</p>
                  )}
                </div>

                <div className="space-y-2">
                  <label
                    htmlFor="city"
                    className="block text-sm font-medium text-[var(--grey-text)]"
                  >
                    City *
                  </label>
                  <select
                    id="city"
                    name="city"
                    value={formData.city}
                    onChange={handleCityChange}
                    className={`w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                      errors.city ? "border-red-500" : "border-gray-300"
                    }`}
                  >
                    <option value="">Select city</option>
                    {allcity.map((city) => (
                      <option key={city.city_name} value={city.table_prefix}>
                        {city.city_name}
                      </option>
                    ))}
                  </select>
                  {errors.city && (
                    <p className="text-sm text-red-500">{errors.city}</p>
                  )}
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="space-y-2">
                  <label
                    htmlFor="latitude"
                    className="block text-sm font-medium text-[var(--grey-text)] flex items-center gap-2"
                  >
                    <svg
                      className="h-4 w-4"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                      />
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                      />
                    </svg>
                    Latitude *
                  </label>
                  <input
                    id="latitude"
                    name="latitude"
                    type="text"
                    placeholder="e.g., 28.6139"
                    value={formData.latitude}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                    className={`w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                      errors.latitude ? "border-red-500" : "border-gray-300"
                    }`}
                  />
                  {errors.latitude && (
                    <p className="text-sm text-red-500">{errors.latitude}</p>
                  )}
                </div>

                <div className="space-y-2">
                  <label
                    htmlFor="longitude"
                    className="block text-sm font-medium text-[var(--grey-text)] flex items-center gap-2"
                  >
                    <svg
                      className="h-4 w-4"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                      />
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                      />
                    </svg>
                    Longitude *
                  </label>
                  <input
                    id="longitude"
                    name="longitude"
                    type="text"
                    placeholder="e.g., 77.2090"
                    value={formData.longitude}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                    className={`w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                      errors.longitude ? "border-red-500" : "border-gray-300"
                    }`}
                  />
                  {errors.longitude && (
                    <p className="text-sm text-red-500">{errors.longitude}</p>
                  )}
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="space-y-2">
                  <label
                    htmlFor="firstTrain"
                    className="block text-sm font-medium text-[var(--grey-text)] flex items-center gap-2"
                  >
                    <svg
                      className="h-4 w-4"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                    First Train *
                  </label>
                  <input
                    id="firstTrain"
                    name="firstTrain"
                    type="time"
                    value={formData.firstTrain}
                    onChange={handleChange}
                    className={`w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                      errors.firstTrain ? "border-red-500" : "border-gray-300"
                    }`}
                  />
                  {errors.firstTrain && (
                    <p className="text-sm text-red-500">{errors.firstTrain}</p>
                  )}
                </div>

                <div className="space-y-2">
                  <label
                    htmlFor="lastTrain"
                    className="block text-sm font-medium text-[var(--grey-text)] flex items-center gap-2"
                  >
                    <svg
                      className="h-4 w-4"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                    Last Train *
                  </label>
                  <input
                    id="lastTrain"
                    name="lastTrain"
                    type="time"
                    value={formData.lastTrain}
                    onChange={handleChange}
                    className={`w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                      errors.lastTrain ? "border-red-500" : "border-gray-300"
                    }`}
                  />
                  {errors.lastTrain && (
                    <p className="text-sm text-red-500">{errors.lastTrain}</p>
                  )}
                </div>

                <div className="space-y-2">
                  <label
                    htmlFor="frequency"
                    className="block text-sm font-medium text-[var(--grey-text)]"
                  >
                    Frequency (minutes) *
                  </label>
                  <input
                    id="frequency"
                    name="frequency"
                    type="text"
                    placeholder="e.g., 5"
                    value={formData.frequency}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                    className={`w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                      errors.frequency ? "border-red-500" : "border-gray-300"
                    }`}
                  />
                  {errors.frequency && (
                    <p className="text-sm text-red-500">{errors.frequency}</p>
                  )}
                </div>
              </div>

              <div className="flex justify-end pt-6 border-t border-gray-200">
                <button
                  type="button"
                  className="px-4 py-2 rounded-md btn-secoundary"
                  onClick={() => navigate(-1)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  onClick={handleSubmit}
                  className="inline-flex items-center justify-center gap-2 bg-[var(--primary-color)] text-white px-4 py-2 rounded-md hover:bg-[var(--primary-hover)] transition duration-200"
                >
                  {station_id ? "Update Station" : "Save Station"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <SuccesModal
        open={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        title={station_id ? "Station Updated Successfully!" : "Station Added Successfully!"}
        subtitle="Your station details have been saved and will now be visible in the metro network."
        autoClose={false}
      />
    </MasterLayout>
  );
}